<!--
 * @Author: wsx
 * @Date: 2021-07-12 15:12:41
 * @LastEditTime: 2021-08-23 11:30:29
 * @LastEditors: Please set LastEditors
 * @Description: 摄像机点位
 * @FilePath: \contingency-manage\src\views\map\SatelliteMap\pointCompont\CameraPoint.vue
-->
<template>
  <div class="cameraPoint" ref="cameraRef">
    <div class="pointContent">
      <div class="pointHead">
        <div class="pointIcon" @click="clickRight" @dblclick="clickPointClick">
          <i class="iconfont icon-shexiangji1"></i>
        </div>
        <div :class="['pointMenuList', { hideShow: !showMenu }]">
          <div
            class="pointMenuItem"
            v-for="item in menuList"
            :style="{ transform: `translate(${item.left}px, ${item.top}px)` }"
            @click="clickMenu(item)"
            :key="item.id"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="pointSpot">
        <div class="spot" :class="'spot' + i" v-for="i in 4" :key="i"></div>
      </div>
      <div class="Ripples"></div>
    </div>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  inject,
  ref,
  nextTick,
} from "vue";
import mapApi from "../js/MapApi";
import { _count } from "@/utils/index.js";
export default defineComponent({
  name: "CameraPoint",
  props: {
    infoData: {
      type: Object,
    },
    drawMethod: {
      type: String,
      default: "openLayer",
    },
  },
  setup(props) {
    const cameraRef = ref(null);
    const data = reactive({
      popup: "",
      poiType: "CameraPoint",
      watchType: "cameraShowState",
      menuList: [
        { id: 1, name: "定位", left: 0, top: -70 },
        { id: 2, name: "视频监控", left: 0, top: 0 },
        { id: 3, name: "视频回放", left: 0, top: 0 },
        { id: 4, name: "编辑", left: 0, top: 0 },
        { id: 5, name: "查看", left: 0, top: 0 },
      ],
      r: 70,
      showMenu: false,
      time: null,
    });
    const refData = toRefs(data);

    const setCameraDialogState = inject("setCameraDialogState", () => {});
    const { drawImages } = mapApi();
    data.menuList = _count(data.menuList, data.r);
    const methods = {
      // 双击
      clickPointClick() {
        clearTimeout(data.time);
        setCameraDialogState(true);
      },
      // 单击事件
      clickRight() {
        clearTimeout(data.time);
        data.time = setTimeout(() => {
          // clickPoint();

          data.showMenu = !data.showMenu;
          setZIndex(cameraRef);
        }, 300);
      },
    };
    // 点击菜单
    const clickMenu = (item) => {
      if (item.id === 2) {
        setCameraDialogState(true);
      }
      closeMenu();
    };
    // 点击地图
    const clickMap = () => {
      closeMenu();
    };
    // 关闭菜单
    const closeMenu = () => {
      data.showMenu = false;
    };
    onMounted(() => {
      // if (props.drawMethod === "openLayer") {
      //   draw(cameraRef, props.infoData);
      // } else if (props.drawMethod === "images") {
      //   drawImage(cameraRef, props.infoData);
      // }
      drawImages(cameraRef, props, data);
    });
    return {
      ...refData,
      cameraRef,
      clickMenu,
      clickMap,
      // clickPoint,
      ...methods,
    };
  },
});
</script>
<style  lang='scss' scoped >
.cameraPoint {
  width: 0px;
  height: 0px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 1;
  .pointContent {
    position: absolute;
    bottom: 100%;
    transform: translateX(-50%);
    pointer-events: none;
    .pointHead {
      color: #3dd5ff;
      width: 50px;
      height: 50px;
      position: relative;
      pointer-events: auto;
      @include flex-row-c-c;
      .pointIcon {
        width: 100%;
        height: 100%;
        @include border-gradient(#0a0e3e, top, #0064e6, #52f9ff);
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        z-index: 2;
        @include flex-row-c-c;
        .iconfont {
          font-size: 26px;
        }
      }
      .pointMenuList {
        position: absolute;
        &.hideShow .pointMenuItem {
          transform: translate(0, 0) scale(0) rotate(720deg) !important;
        }
        .pointMenuItem {
          width: 50px;
          height: 50px;
          $bg: rgba(
            $color: #122a42,
            $alpha: 0.8,
          );
          @include border-gradient($bg, top, #0064e6, #52f9ff);
          text-align: center;
          border-radius: 50%;
          font-size: 14px;
          letter-spacing: 2px;
          position: absolute;
          left: -25px;
          top: -25px;
          z-index: 1;
          cursor: pointer;
          @include flex-row-c-c;
          transition: all 0.3s;
        }
      }
    }
    .pointSpot {
      pointer-events: none;
      @include flex-col-c-c;
      .spot {
        border-radius: 50%;
        background-color: #42d2fd;
        margin-top: 5px;
        &.spot4 {
          width: 3px;
          height: 3px;
        }
        &.spot3 {
          width: 5px;
          height: 5px;
        }
        &.spot2 {
          width: 7px;
          height: 7px;
        }
        &.spot1 {
          width: 9px;
          height: 9px;
        }
      }
    }
    .Ripples {
      @include animation-dian;
      background-color: red;
    }
    .Ripples:before {
      animation-delay: 1s;
    }

    .Ripples:after,
    .Ripples:before {
      content: "";
      width: 100%;
      height: 100%;
      background-color: #0064e6;
      animation-name: myBMapPoint;
      animation-duration: 2s;
      animation-fill-mode: backwards;
      animation-iteration-count: infinite;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 50%;
    }
    @keyframes myBMapPoint {
      from {
        opacity: 1;
        transform: scale(1);
      }

      to {
        opacity: 0;
        transform: scale(15);
      }
    }
  }
}
</style>
